import React, { useEffect, useState } from 'react';
import { UsersIcon, FlameIcon } from 'lucide-react';
const TOTAL = 1500;
const INITIAL_TAKEN = 1213;
const REMAINING_KEY = 'cv360_remaining_seed';
// Slowly decrement remaining seats over time to add real urgency.
function readSeed(): number {
  try {
    if (typeof window === 'undefined') return INITIAL_TAKEN;
    const raw = window.localStorage.getItem(REMAINING_KEY);
    if (raw) {
      const n = parseInt(raw, 10);
      if (!Number.isNaN(n) && n >= INITIAL_TAKEN && n < TOTAL) return n;
    }
  } catch {
    /* ignore */
  }
  return INITIAL_TAKEN;
}
function persistSeed(val: number) {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(REMAINING_KEY, String(val));
  } catch {
    /* ignore */
  }
}
export function ScarcityBar() {
  const [taken, setTaken] = useState<number>(INITIAL_TAKEN);
  useEffect(() => {
    const initial = readSeed();
    setTaken(initial);
    persistSeed(initial);
    // every 35-90s, one new "spot" gets taken
    let cancelled = false;
    const tick = () => {
      if (cancelled) return;
      setTaken(prev => {
        const next = Math.min(TOTAL - 50, prev + 1);
        persistSeed(next);
        return next;
      });
      const delay = 35000 + Math.random() * 55000;
      window.setTimeout(tick, delay);
    };
    const timeoutId = window.setTimeout(tick, 20000);
    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, []);
  const remaining = TOTAL - taken;
  const pct = Math.min(100, Math.round(taken / TOTAL * 100));
  const danger = remaining < 350;
  return <div className="bg-white border-2 border-orange-300 rounded-2xl px-4 py-4 shadow-md" data-id="element-202">
      <div className="flex items-center justify-between gap-2 mb-2" data-id="element-203">
        <span className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-orange-700 uppercase tracking-wide" data-id="element-204">
          <FlameIcon className="w-4 h-4" data-id="element-205" /> Últimos cupos
        </span>
        <span className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-slate-600" data-id="element-206">
          <UsersIcon className="w-4 h-4" data-id="element-207" /> {taken.toLocaleString('es-AR')} /{' '}
          {TOTAL.toLocaleString('es-AR')}
        </span>
      </div>

      <div className="relative w-full h-3.5 bg-slate-100 rounded-full overflow-hidden" data-id="element-208">
        <div className={`h-full rounded-full transition-all duration-700 ${danger ? 'bg-gradient-to-r from-orange-500 to-red-500' : 'bg-gradient-to-r from-green-500 to-emerald-500'}`} style={{
        width: `${pct}%`
      }} data-id="element-209" />
      </div>

      <div className="flex items-center justify-between gap-2 mt-2 text-xs sm:text-sm" data-id="element-210">
        <span className="font-bold text-slate-700" data-id="element-211">
          {taken.toLocaleString('es-AR')} cupos ocupados
        </span>
        <span className={`font-extrabold ${danger ? 'text-red-600' : 'text-green-700'}`} data-id="element-212">
          ¡Quedan solo {remaining.toLocaleString('es-AR')}!
        </span>
      </div>
    </div>;
}